module.exports = __webpack_public_path__ + "img/icone_sac_inventaire.9a1f04a9.svg";